import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=798a1b0b&scoped=true&"
var script = {}
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=798a1b0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a1b0b",
  null
  
)

export default component.exports